import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {BaseService} from '~/app/core/common/services/base.service';
import {CustomerCategory} from '~/app/core/common/models/customerCategory';

import {ApiService} from '~/app/core/common/services/api.service';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {GoogleAnalyticsService} from '~/app/core/common/services/google-analytics.service';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {InternetConnectionService} from '~/app/shared/services/internet-connection.service';
import {ErrorApiService} from '~/app/core/common/test/error-api.service';

@Injectable({
    providedIn: 'root'
})
export class ProfileCategoriesService extends BaseService {
    public customerCategories: CustomerCategory[];
    private _initialized = false;
    private _profileCategoryCategoriesListView: string[] = [];
    private _profileItemCategoriesListView: string[] = [];
    private _selectedCategory: CustomerCategory;
    private _originalList: CustomerCategory[];

    constructor(private _http: HttpClient,
                public apiService: ApiService,
                private _storeListService: StoreListService,
                public googleAnalyticsService: GoogleAnalyticsService,
                public internetConnectionService: InternetConnectionService,
                public errorApiService: ErrorApiService,
                public applicationSettingsHelper: ApplicationSettingsHelper) {
        super(_http,
            googleAnalyticsService,
            internetConnectionService,
            errorApiService,
            applicationSettingsHelper);
        this.initialized = false;
    }

    get initialized(): boolean {
        return this._initialized;
    }

    set initialized(value: boolean) {
        this._initialized = value;
    }

    get profileCategoryCategoriesListView(): string[] {
        return this._profileCategoryCategoriesListView;
    }

    set profileCategoryCategoriesListView(value: string[]) {
        this._profileCategoryCategoriesListView = value;
    }

    get profileItemCategoriesListView(): string[] {
        return this._profileItemCategoriesListView;
    }

    set profileItemCategoriesListView(value: string[]) {
        this._profileItemCategoriesListView = value;
    }

    get selectedCategory(): CustomerCategory {
        return this._selectedCategory;
    }

    set selectedCategory(value: CustomerCategory) {
        this._selectedCategory = value;
    }

    get originalList(): CustomerCategory[] {
        return this._originalList;
    }

    set originalList(value: CustomerCategory[]) {
        this._originalList = value;
    }

    async getCategories(customer_number: string) {
        const results = await this.getHttp('getCategories', 'profile-categories-service', this.apiService.profileItemCategoriesURL.replace('customer_number', customer_number))
            .toPromise();
        return results as CustomerCategory[];
    }

    addCategory(category_description: string, customer_number: string) {
        return this.postHttp(
            'addCategory',
            'profile-categories-service',
            this.apiService.profileAddCategoryURL
                .replace('customer_number', customer_number)
                .replace('category_description', category_description))
            .toPromise()
            .then(response => response);
    }

    deleteCategory(category_id: string) {
        return this.deleteHttp(
            'deleteCategory',
            'profile-categories-service',
            this.apiService.profileDeleteCategoryURL
                .replace('category_id', category_id))
            .toPromise()
            .then(response => response);
    }

    async getCustomerCategories() {
        const pickedCustomerId = await this._storeListService.pickedCustomerIdVerify();
        this.customerCategories = await this.getCategories(pickedCustomerId.toString());
        this.customerCategories.forEach(category => {
            category.documentType = 'customer_categories';
        });
        this.initializeCategories();
        return this.customerCategories;
    }

    initializeCategories() {
        const critical = '00001';
        const hold = '00002';
        this.customerCategories.push(new CustomerCategory(+critical, 'CRITICAL ITEMS', 'CRITICAL ITEMS', false, 'customer_categories'));
        this.customerCategories.push(new CustomerCategory(+hold, 'HOLD ITEMS', 'HOLD ITEMS', false, 'customer_categories'));
        this.customerCategories = this.customerCategories.sort((a, b) => {
            return (a.description > b.description ? 1 : -1);
        });
        this.customerCategories.forEach(cat => cat.selected = false);
        this.originalList = this.customerCategories;
        this.selectedCategory = this.customerCategories.find(category => category.description === 'ALL ITEMS');
        this.updateCategoryList();
        this.selectedCategory = this.customerCategories[0];
        this.initialized = true;
    }

    sortCategoryList() {
        this.profileItemCategoriesListView.sort((a, b) => {
            return (a > b ? 1 : -1);
        });
        this.profileCategoryCategoriesListView.sort((a, b) => {
            return (a > b ? 1 : -1);
        });
    }

    updateCategoryList() {
        this.profileCategoryCategoriesListView = this.customerCategories.map(category => category.description).filter(e => {
            if ((e === 'CRITICAL ITEMS') || (e === 'HOLD ITEMS') || e === 'ALL ITEMS') {
                return false;
            }
            return true;
        });
        this.profileItemCategoriesListView = this.customerCategories.map(category => category.description).filter(e => {
            if ((e === 'CRITICAL ITEMS') || (e === 'HOLD ITEMS')) {
                return false;
            }
            return true;
        });
        this.sortCategoryList();
    }
}
